import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentSpecialFreightManagerEndpoint } from '../../constants';
import { LinkInfoType, SpecialFreightIdView } from '../../../../models';
import { SpecialFreightMilestoneModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightTrackingService {
  constructor(private http: WrapperHttpService) {}
  getMilestonesData(
    identifier: SpecialFreightIdView,
  ): Observable<{ milestones: SpecialFreightMilestoneModel[]; linkInfoType: LinkInfoType }> {
    const url = `${API_URL}${ShipmentSpecialFreightManagerEndpoint.Base}${
      ShipmentSpecialFreightManagerEndpoint.SpecialFreights
    }${ShipmentSpecialFreightManagerEndpoint.Milestones}?${getQueryStringFromObject(identifier)}`;

    return this.http.withLoading().get(url);
  }
}
